const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { gql, useQuery } from '@apollo/client';
import { CONTACT_ASSOCIATION_SPEC, CONTRACT_PROPERTY_VALUE_FIELDS, LINE_ITEM_ASSOCIATION_SPEC, PROPERTY_VALUE_FIELDS_FRAGMENT } from 'commerce-contract-lib/fragments/PropertyFragment';
import { CONTRACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useQuerySelector } from 'utility-belt/hooks/useQuerySelector';
import { DEFAULT_QUERY_OPTIONS } from '../constants';
export const FETCH_CONTRACT_DATA = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"FetchContractData\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"properties\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"associations\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"AssociationSpec\"}}}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currency\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"homeCurrency\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currencyCode\"}}]}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObject\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"StringValue\",\"value\":\"0-721\",\"block\":false}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"userPermissions\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currentUserCanView\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currentUserCanEdit\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currentUserCanCommunicate\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currentUserCanDelete\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currentUserCanMerge\"}}]}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"BasicCrmObject\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"properties\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"names\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"properties\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"ContractPropertyValueFields\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associationsBySpec\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"associationSpecs\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"associations\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associatedObjects\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"first\"},\"value\":{\"kind\":\"IntValue\",\"value\":\"200\"}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"__typename\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"edges\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"__typename\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"node\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"__typename\"}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"LineItem\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"allProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyValueFieldsFragment\"}}]}}]}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Contact\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"defaultProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"email\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyValueFieldsFragment\"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: _unique([{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "FetchContractData"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "properties"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "String"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "associations"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AssociationSpec"
              }
            }
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "currency"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "homeCurrency"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currencyCode"
                }
              }]
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObject"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "StringValue",
            value: "0-721",
            block: false
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "id"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "userPermissions"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currentUserCanView"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currentUserCanEdit"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currentUserCanCommunicate"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currentUserCanDelete"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currentUserCanMerge"
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "BasicCrmObject"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "properties"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "names"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "properties"
                    }
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "FragmentSpread",
                    name: {
                      kind: "Name",
                      value: "ContractPropertyValueFields"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "associationsBySpec"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "associationSpecs"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "associations"
                    }
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "associatedObjects"
                    },
                    arguments: [{
                      kind: "Argument",
                      name: {
                        kind: "Name",
                        value: "first"
                      },
                      value: {
                        kind: "IntValue",
                        value: "200"
                      }
                    }],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "__typename"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "edges"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "__typename"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "node"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "id"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "__typename"
                                }
                              }, {
                                kind: "InlineFragment",
                                typeCondition: {
                                  kind: "NamedType",
                                  name: {
                                    kind: "Name",
                                    value: "LineItem"
                                  }
                                },
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "allProperties"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{
                                        kind: "FragmentSpread",
                                        name: {
                                          kind: "Name",
                                          value: "PropertyValueFieldsFragment"
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }, {
                                kind: "InlineFragment",
                                typeCondition: {
                                  kind: "NamedType",
                                  name: {
                                    kind: "Name",
                                    value: "Contact"
                                  }
                                },
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "id"
                                    }
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "defaultProperties"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{
                                        kind: "Field",
                                        name: {
                                          kind: "Name",
                                          value: "email"
                                        },
                                        selectionSet: {
                                          kind: "SelectionSet",
                                          selections: [{
                                            kind: "FragmentSpread",
                                            name: {
                                              kind: "Name",
                                              value: "PropertyValueFieldsFragment"
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }].concat(CONTRACT_PROPERTY_VALUE_FIELDS.definitions, PROPERTY_VALUE_FIELDS_FRAGMENT.definitions))
});
export const contractProperties = ['hs_name', 'hs_hubspot_billing_enabled', 'hs_object_source', 'hs_status', 'hs_collection_process', 'hs_termination_date', 'hs_currency_code'];
export function normalizeContractData(data) {
  var _associationsBySpec$r, _associations$toLineI, _ref, _propertyMap$hs_curre, _propertyMap$hs_curre2;
  if (!(data !== null && data !== void 0 && data.crmObject) || data.crmObject.__typename !== 'BasicCrmObject') {
    return null;
  }
  const {
    crmObject: {
      id,
      properties,
      associationsBySpec,
      userPermissions
    },
    currency: {
      homeCurrency
    }
  } = data;
  const associations = (_associationsBySpec$r = associationsBySpec === null || associationsBySpec === void 0 ? void 0 : associationsBySpec.reduce((acc, association) => {
    var _association$associat, _association$associat4;
    const lineItemAssociation = (_association$associat = association.associatedObjects) === null || _association$associat === void 0 || (_association$associat = _association$associat.edges) === null || _association$associat === void 0 ? void 0 : _association$associat.find(edge => {
      var _edge$node;
      return (edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.__typename) === 'LineItem';
    });
    if (lineItemAssociation) {
      var _association$associat2, _association$associat3;
      acc.toLineItems = (_association$associat2 = (_association$associat3 = association.associatedObjects) === null || _association$associat3 === void 0 || (_association$associat3 = _association$associat3.edges) === null || _association$associat3 === void 0 ? void 0 : _association$associat3.map(edge => edge.node)) !== null && _association$associat2 !== void 0 ? _association$associat2 : [];
    }
    const contactAssociation = (_association$associat4 = association.associatedObjects) === null || _association$associat4 === void 0 || (_association$associat4 = _association$associat4.edges) === null || _association$associat4 === void 0 ? void 0 : _association$associat4.find(edge => {
      var _edge$node2;
      return (edge === null || edge === void 0 || (_edge$node2 = edge.node) === null || _edge$node2 === void 0 ? void 0 : _edge$node2.__typename) === 'Contact';
    });
    if (contactAssociation) {
      var _association$associat5, _association$associat6;
      acc.toContacts = (_association$associat5 = (_association$associat6 = association.associatedObjects) === null || _association$associat6 === void 0 || (_association$associat6 = _association$associat6.edges) === null || _association$associat6 === void 0 ? void 0 : _association$associat6.map(edge => edge.node)) !== null && _association$associat5 !== void 0 ? _association$associat5 : [];
    }
    return acc;
  }, {
    toLineItems: [],
    toContacts: []
  })) !== null && _associationsBySpec$r !== void 0 ? _associationsBySpec$r : {
    toLineItems: [],
    toContacts: []
  };
  const propertyMap = (properties !== null && properties !== void 0 ? properties : []).reduce((acc, property) => {
    acc[property.name] = property;
    return acc;
  }, {});
  const lineItemCurrencyCode = associations === null || associations === void 0 || (_associations$toLineI = associations.toLineItems) === null || _associations$toLineI === void 0 || (_associations$toLineI = _associations$toLineI[0]) === null || _associations$toLineI === void 0 || (_associations$toLineI = _associations$toLineI.allProperties) === null || _associations$toLineI === void 0 || (_associations$toLineI = _associations$toLineI.find(property => property.name === 'hs_line_item_currency_code')) === null || _associations$toLineI === void 0 ? void 0 : _associations$toLineI.value;
  const currencyCode = (_ref = (_propertyMap$hs_curre = (_propertyMap$hs_curre2 = propertyMap.hs_currency_code) === null || _propertyMap$hs_curre2 === void 0 ? void 0 : _propertyMap$hs_curre2.value) !== null && _propertyMap$hs_curre !== void 0 ? _propertyMap$hs_curre : lineItemCurrencyCode) !== null && _ref !== void 0 ? _ref : homeCurrency.currencyCode;
  return {
    id,
    userPermissions,
    properties: propertyMap,
    associations,
    currencyCode
  };
}
export function useFetchContractData({
  objectId,
  objectTypeId
}, options = {}) {
  return useQuery(FETCH_CONTRACT_DATA, Object.assign({}, DEFAULT_QUERY_OPTIONS, options, {
    variables: Object.assign({
      objectId,
      properties: contractProperties,
      associations: [LINE_ITEM_ASSOCIATION_SPEC, CONTACT_ASSOCIATION_SPEC]
    }, options.variables || {}),
    skip: options.skip || !objectId || objectId === -1 || objectTypeId !== CONTRACT_TYPE_ID
  }));
}
export function useContractData(descriptor, options = {}) {
  return useQuerySelector(useFetchContractData(descriptor, options), normalizeContractData);
}